import { Tooltip } from '@mui/material'
import React, { forwardRef, cloneElement } from 'react'

const TooltipWrapper = forwardRef(({ children, ...props }, ref) => (
  <div ref={ref}>{cloneElement(children, props)}</div>
))

export const MyTooltip = ({ children, ...props }) => {
  return (
    <>
      <Tooltip placement='top' {...props}>
        <TooltipWrapper>{children}</TooltipWrapper>
      </Tooltip>
    </>
  )
}
